import portalApiClient from "./portalAxios";
import {
  PortalDisputeDetail,
  PortalLoginResponse,
  PortalMeResponse,
} from "../types";

export interface PortalBillingSubscription {
  planName: string;
  amountCents: number;
  currency: string;
  status: string;
  currentPeriodEnd?: string | null;
}

export interface PortalBillingPayment {
  id: string;
  amountCents: number;
  currency: string;
  status: string;
  paidAt?: string | null;
}

export interface PortalClientDocument {
  id: string;
  clientId: string;
  fileName: string;
  contentType: string;
  fileSize: number;
  category: string;
  description?: string | null;
  uploadedBy?: string | null;
  createdAt: string;
}

export const portalApi = {
  login: async (email: string, password: string): Promise<PortalLoginResponse> => {
    const response = await portalApiClient.post<PortalLoginResponse>("/portal/login", { email, password });
    return response.data;
  },

  me: async (): Promise<PortalMeResponse> => {
    const response = await portalApiClient.get<PortalMeResponse>("/portal/me");
    return response.data;
  },

  trackReferral: async (referralCode: string): Promise<void> => {
    await portalApiClient.post("/portal/track-referral", { referralCode: referralCode.trim() });
  },

  disputes: async (): Promise<PortalDisputeDetail[]> => {
    const response = await portalApiClient.get<PortalDisputeDetail[]>("/portal/disputes");
    return response.data;
  },

  documents: async (): Promise<PortalClientDocument[]> => {
    const response = await portalApiClient.get<PortalClientDocument[]>("/portal/documents");
    return response.data;
  },

  getBillingSubscription: async (): Promise<PortalBillingSubscription | null> => {
    try {
      const response = await portalApiClient.get<PortalBillingSubscription>("/portal/billing/subscription");
      return response.data;
    } catch (e: unknown) {
      const status = (e as { response?: { status?: number } })?.response?.status;
      if (status === 404) {
        return null;
      }
      throw e;
    }
  },

  getBillingPayments: async (): Promise<PortalBillingPayment[]> => {
    const response = await portalApiClient.get<PortalBillingPayment[]>("/portal/billing/payments");
    return response.data;
  },

  downloadDocument: async (documentId: string, fileName: string): Promise<void> => {
    const res = await portalApiClient.get(`/portal/documents/${documentId}/download`, {
      responseType: "blob",
    });
    const blob = res.data as Blob;
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  },
};
